<template>
  <div class="dropdown-item">
    <h4
      type="secondary"
      class="dropdown-toggle mb-0"
    >{{group.translation.name}}</h4>
    <template v-for="item in group.items">
      <DrawerCustomGroup v-if="item.type === 'group' && !!item.status" :group="item" :key="item.id"/>
      <DrawerCustomOption v-if="item.type === 'option' && !!item.status" :option="item" :key="item.id"/>
    </template>
  </div>
</template>

<script>
import DrawerCustomOption from './DrawerCustomOption';
export default {
  name: "DrawerCustomGroup",
  components: {
    DrawerCustomOption
  },
  props: {
    group: Object,
  },
  computed: {
    color() {
      return this.$store.getters.COLOR;
    }
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    },
  }
};
</script>

<style lang="scss">
</style>
